import React, { Component } from 'react'
import search from './search.svg'


export class SearchBlock extends Component {
  state = {
    username: ''
  }

  
  handleChange = (e) => {
    this.setState({ username: e.target.value })
  }

  handleSubmit = async (e) => {
    e.preventDefault()

    const username = this.state.username.trim()
    if (!username) return

    try {
      const response = await fetch(
      `https://api.github.com/users/${username}`
      )

      if (response.status === 404) {
        this.props.onError('User not found')
        return
      }

      if (!response.ok) {
        this.props.onError('Something went wrong')
        return
      }

      const data = await response.json()
      this.props.onSearch(data)

    } catch (err) {
      this.props.onError('Network error')
    }
  }

  render() {
    return (
      <section className='SearchBlock'>
        <div className='text-search'>
          <h2>Find the author's information on GitHub.</h2>
          <p>
            Enter a GitHub username below to view profile details, repositories, and activity
          </p>
        </div>

        <form className='search-form' onSubmit={this.handleSubmit}>
          <input 
            type="text"
            className='input-search'
            value={this.state.username}
            onChange={this.handleChange}
            placeholder="write a nickname"
            maxLength={39}
          />

          <button type="submit" className='button-search'><img src={search}/>
          </button>
        </form>
      </section>
    )
  }
}

export default SearchBlock